export const FIELDS = [
  { fieldName: 'email', placeholder: 'Email' },
  { fieldName: 'firstName', placeholder: 'First name' },
  { fieldName: 'lastName', placeholder: 'Last name' }
];
